var update = function (items, filteringData) {
    var filteringText = filteringData.filteringText, filteringFields = filteringData.filteringFields, filteringFunction = filteringData.filteringFunction;
    return {
        items: filteringText && filteringFunction
            ? items.filter(function (item) { return filteringFunction(item, filteringText, filteringFields); })
            : items.slice(),
        filteringText: filteringText,
        filteringFields: filteringFields,
        filteringFunction: filteringFunction
    };
};
var compare = function (oldFilteringData, newFilteringData, userAction) {
    return userAction && oldFilteringData.filteringText !== newFilteringData.filteringText;
};
var defaultFilteringFunction = function (item, filteringText, filteringFields) {
    if (filteringFields === void 0) { filteringFields = []; }
    if (filteringFields.length === 0) {
        filteringFields = Object.keys(item);
    }
    var iContains = function (haystack, needle) {
        return String(haystack)
            .toLowerCase()
            .indexOf(needle.toLowerCase()) > -1;
    };
    return filteringFields.some(function (key) {
        return iContains(item[key], filteringText);
    });
};
export default {
    update: update,
    compare: compare,
    defaultFilteringFunction: defaultFilteringFunction
};
//# sourceMappingURL=utils.js.map